import { useEffect, useState } from 'react';
import { axiosInstance } from 'utils/axios';

// material-ui
import { Box, Button, Grid, Typography, TextField, Autocomplete, CircularProgress, Checkbox } from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';
import { gridSpacing } from 'app/constant';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import StickyHeadTable from './components/StickyHeadTable';
import { warningAlert, successAlert, errorAlert } from 'ui-component/Toasts';
import useFetchData from 'hooks/useFetchData';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

const RankingProfit = () => {
    const token = useSelector(selectCurrentToken);

    const [rankingProfits, setRankingProfits] = useState([]);
    const [filterFrom, setfilterFrom] = useState(dayjs().subtract(1, 'days'));
    const [filterTo, setfilterTo] = useState(dayjs());
    const [filterLoginUsername, setfilterLoginUsername] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);

    const fetchRankingProfits = async () => {
        if (!filterFrom.isValid() || !filterTo.isValid()) {
            warningAlert('Please fill up all required fields.');
            return;
        }
        let fetchRankingProfitsUrl = `/RankingProfitDetails/All?dateFrom=${filterFrom.format('YYYY-MM-DD')}&dateTo=${filterTo.format(
            'YYYY-MM-DD'
        )}`;
        if (filterLoginUsername !== '') {
            fetchRankingProfitsUrl += `&loginUserName=${filterLoginUsername}`;
        }
        setLoading(true);
        setFilterBtnDisabled(true);
        try {
            const res = await axiosInstance.get(fetchRankingProfitsUrl, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setRankingProfits(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
            setFilterBtnDisabled(false);
        }
    };

    useEffect(() => {
        fetchRankingProfits();
    }, [token]);

    const { data: loginUsernameOptions } = useFetchData('/Customer/LoginUserNames');

    return (
        <Grid container item xs={12} padding="20px">
            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>From :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterFrom}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setfilterFrom(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>To :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterTo}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setfilterLockSalesTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Login UserName :
                        </Typography>
                        <Autocomplete
                            freeSolo
                            value={filterLoginUsername}
                            onChange={(event, newValue) => {
                                setfilterLoginUsername(newValue);
                            }}
                            inputValue={filterLoginUsername}
                            onInputChange={(event, newInputValue) => {
                                setfilterLoginUsername(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={loginUsernameOptions}
                            sx={{ width: 170 }}
                            renderInput={(params) => <TextField {...params} />}
                            disableClearable
                        />
                    </Box>
                </Grid>

                <Grid item container xs={12} md={12} lg={12}>
                    <Button
                        variant="contained"
                        sx={{
                            float: 'right',
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '30px'
                        }}
                        onClick={() => fetchRankingProfits()}
                        disabled={filterBtnDisabled}
                    >
                        Filter
                    </Button>
                </Grid>
                <Box sx={{ width: '100%', minHeight: '200px' }}>
                    {isLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <StickyHeadTable rankingProfits={rankingProfits} />
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default RankingProfit;
